<div class="min-h-screen w-full overflow-hidden flex items-center justify-center bg-primary-100">
    <router-outlet />
</div>
